/* jshint ignore:start */
/* eslint-disable */
import Vue from 'vue'
import Vuex from 'vuex'
import UserService from '../../services/UserService';

Vue.use(Vuex)
const state = {
    loading: false,
    permission_List:[],
    checkPermissionEdit:false,
    // Branch_List: [],
    // Department_List: [],
    // Position_List: [],
    // Employee_List: [],
    // SelectBranch: 'All',
    // SelectDepartment: 'All',
    // SelectPosition: 'All',
    // FromDate: "",
    // ToDate: "",
    // SearchData: '',
    // showFilter: 0,
    Errormsg: ''
}

const getters = {
    // getShowFilter: state => {
    //     return state.showFilter
    // },
    // getGetSearch: state => {
    //     return state.SearchData
    // },
}

const mutations = {
    // setShowFilter(state, {
    //     status
    // }) {
    //     state.showFilter = status
    //     console.log(state.showFilter);
    // },
    getAllPermission(state, {permissionList}) {
        state.permission_List = permissionList
        state.loading = false
    },
    getCheckPermission(state, {checkEdit}) {
        state.checkPermissionEdit = checkEdit
    },
    Permissionlogout(state){
        state.permission_List = []
      }
    
}

const actions = {
    async getPermission({commit},{code}) {
      
            let Res_list = []
            await UserService.getpermissionByusercode(code)
                .then(res => {
                    console.log("rrsss"+code)
                    if (res && res.data != undefined) {
                        Res_list = res.data.permission; 
                    }
                })
                .catch(err => {
                    console.log(err)
                })

            await commit("getAllPermission", {
                permissionList: Res_list
            })
        
      
    },
    async getPermissionEdit({commit},page){
        let checkEdit = false
        if(state.permission_List.length != 0){
             state.permission_List.forEach(element => {
                 if(page == element.module_name){
                    checkEdit = element.edit;
                 }
             });
        }
        else{
            checkEdit = false;
        }
        await commit("getcheckPermission", {
            checkPermissionEdit: checkEdit
        })
        
    }
    // async setSearchData({
    //     commit,
    //     dispatch
    // }, {
    //     value
    // }) {
    //     await commit("selectedSearchData", {
    //         data: value
    //     })
    // }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}